"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LUX_LOYALTY_POINTS_PER_STATUS_CREDIT = void 0;
/**
 * The number of points per status credit. Business directive is that this value is 1000/9
 */
exports.LUX_LOYALTY_POINTS_PER_STATUS_CREDIT = 111.11111111111111;
